import { memo } from "react";

const CfdEmptyCard = ({ activeTab }) => {
  return (
    <div
      style={{
        fontFamily: "graphikregular",
        fontSize: 14,
        color: "#333",
        paddingLeft:8
      }}
    >
      {activeTab === "saved"
        ? "No Saved Properties."
        : activeTab === "all"
        ? "No properties found"
        : "No Offer History found"}
    </div>
  );
};

export default memo(CfdEmptyCard);
